import { useState } from 'react';
import { apiURL } from '../../consts/URLs';
import { GET_USER, USERS, LOGIN, USER, CATEGORIES } from '../endpointList';
import { fetchRequest, getOptions } from '../utils';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';

const token = getCookie(cookieName.token);

const useUser = () => {
    const [getUserResponse, setGetUserResponse] = useState<any>();
    const [getUserResult, setGetUserResult] = useState<any>();
    const [updateUserResponse, setUpdateUserResponse] = useState<any>();
    const [updateUserResult, setUpdateUserResult] = useState<any>();
    const [deleteResponse, setDeleteResponse] = useState<any>();
    const [deleteResult, setDeleteResult] = useState<any>();
    const [getUsersListResponse, setGetUsersListResponse] = useState<any>();
    const [getUsersListResult, setGetUsersListResult] = useState<any>();

    const [userEditResponse, setUserEditResponse] = useState<any>();
    const [userEditResult, setUserEditResult] = useState<any>();

    const getUserByToken = (paramToken: string) => {
        const url = `${apiURL}/${GET_USER}`;
        const options = getOptions({ method: 'POST', body: { token: paramToken } });
        fetchRequest(url, options, setGetUserResponse, setGetUserResult);
    };
    const updateUser = (obj: any, id: number) => {
        const url = `${apiURL}/${USER}/${id}`;
        const options = getOptions({
            method: 'PUT',
            body: { ...obj },
            token: token,
        });
        fetchRequest(url, options, setUpdateUserResponse, setUpdateUserResult);
    };

    const deleteUser = (id: number) => {
        const url = `${apiURL}/${USERS}/${id}`;
        const options = getOptions({
            method: 'DELETE',
            token: token,
        });
        fetchRequest(url, options, setDeleteResponse, setDeleteResult);
    };

    const getUsersList = () => {
        const url = `${apiURL}/${USERS}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetUsersListResponse, setGetUsersListResult);
    };

    const editUser = (obj: any) => {
        const queryParams = new URLSearchParams();
        if (obj.name) {
            queryParams.append('name', obj.name);
        }

        if (obj.email) {
            queryParams.append('email', obj.email);
        }

        if (obj.password) {
            queryParams.append('password', obj.password);
        }

        const url = `${apiURL}/${USERS}/${obj.id}?${queryParams}`;
        const options = getOptions({ method: 'PUT', token: token });
        fetchRequest(url, options, setUserEditResponse, setUserEditResult);
    };

    const RESPONSES = {
        getUserResponse,
        getUsersListResponse,
        updateUserResponse,
        deleteResponse,
        userEditResponse,
    };

    const RESULTS = {
        getUserResult,
        getUsersListResult,
        updateUserResult,
        deleteResult,
        userEditResult,
    };

    const CTAs = {
        getUserByToken,
        getUsersList,
        updateUser,
        deleteUser,
        editUser,
    };

    return { RESPONSES, RESULTS, CTAs };
};
export default useUser;
